// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__2tYEU","paymentContainer":"PaymentPage_paymentContainer__1MJos"};